import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/motion/Reveal";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FaqSection = ({ limit }) => {
  const list = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="faq-section">
      <div className="container-x grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-16 items-start">
        <SectionHeading
          eyebrow="Quick Answers"
          title={<>What families ask <span className="text-brand-red">before they buy.</span></>}
          sub="Still have questions? Call a specialist any time — day or night."
        />

        <Reveal>
          <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
            {list.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-brand-line"
              >
                <AccordionTrigger className="text-left font-display font-bold text-xl text-brand-navy py-6 hover:no-underline hover:text-brand-red [&>svg]:w-6 [&>svg]:h-6 [&>svg]:text-brand-red">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-ink2 text-[17px] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
